import { SearchableAccordionsViewWebComponent } from './component/SearchableAccordionsViewWebComponent';

export { SearchableAccordionsViewWebComponent };
